import timezonesContries from './../config/timezones-countries'

export default () => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return timezonesContries[userTimezone] || 'br'
}
